import { Navigate } from "react-router-dom";
import { latVar } from "../../utils/utils";

interface ProtectedRouteProps {
  Component: React.ComponentType;
  redirectPath?: string;
}

const ProtectedRoute = ({ Component }: ProtectedRouteProps) => {
  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj && JSON.parse(userObj);

  if (!!userDetail?.id) {
    return (
      <Navigate
        to={
          `/properties?lat=${latVar.lat}&lng=${latVar.lng}&zoom=${latVar.zoom}&state=CA&status=Active`
        }
      />
    );
  }
  return <Component />;
};

export default ProtectedRoute;
